export default class {
  constructor($uibModalInstance, datapointListCallback, preSelectedDatapoints, maxSelection) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;

    this.datapointListCallback = datapointListCallback();
    this.allDatapoints = [];
    this.selectedDatapoints = [...preSelectedDatapoints];
    this.loading = true;
    this.maxSelection = maxSelection;
  }

  $onInit() {
    this.datapointListCallback.then((result) => {
      if (result) {
        this.loading = false;
        this.allDatapoints = result || [];
        this.allDatapoints = this.allDatapoints
          .map((datapoint) => {
            return {
              ...datapoint,
              selected: !!this.selectedDatapoints.find(
                (selected) => selected.key === datapoint.key,
              ),
            };
          })
          .sort((a, b) => (a.title.toLowerCase() >= b.title.toLowerCase() ? 1 : -1));
      }
    });
  }

  confirm() {
    this.$uibModalInstance.close(this.selectedDatapoints);
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }

  clickedDatapoint(datapoint) {
    const isAlreadySelected = this.selectedDatapoints.find(
      (selectedDatapoint) => selectedDatapoint.dataId === datapoint.dataId,
    );

    if (isAlreadySelected) {
      this.selectedDatapoints = this.selectedDatapoints.filter(
        (selectedDatapoint) => selectedDatapoint.dataId !== datapoint.dataId,
      );
      datapoint.selected = false;
    } else if (this.selectedDatapoints.length < this.maxSelection) {
      this.selectedDatapoints.push(datapoint);
      datapoint.selected = true;
    }
  }
}
